// extracted by mini-css-extract-plugin
module.exports = {"wrapperStyles":"Graphics2d_wrapperStyles__3cPvl","canvasStyles":"Graphics2d_canvasStyles__2PnLZ"};